define('casino/providers/netent/NetEntLiveCasino',[],function() {
    'use strict';

    function NetEntLiveCasino(casino, gameFunctions) {
        if (!(this instanceof NetEntLiveCasino)) {
            throw new TypeError('NetEntLiveCasino constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    // TODO: rewrite livecasino as regular netent, remove GetNetEntGameInfo altogether
    function netEntLiveCasinoConfiguration(netEntLiveCasino, game, options) {
        var provider = netEntLiveCasino.casino.getProvider(game);
        var casinoId = 'cogaming';
        var gameHostURL  = provider.staticURL + '/live_casino/unbranded/roulette/';
        if (provider.branding &&  provider.branding !== 'unbranded'){
            gameHostURL  = provider.staticURL + '/live_casino/roulette/';
            casinoId = 'comeon';
        }
        $.ajax({
            url: '/pp?flow=GetNentEntGameInfo&onlySession=true&mode=real&gameCode=' + game.code + '&gameId=' + game.id,
            type: 'POST'
        }).done(function(data) {
            var flashVars = {
                lang: 'en',
                lobbyURL: 'window.close()',
                varsRequestURL: encodeURI(provider.gameURL + '/comm/Events'),
                jsonRequestURL: encodeURI(provider.gameURL),
                gameHostURL: gameHostURL,
                casinoId: casinoId,
                branding: provider.branding,
                brandingLocale: 'en',
                localizationId: 'en',
                wmode: 'direct',
                sessionid: data.sessionId
            };
            var flashParams = {
                name: 'lc lobby',
                bgcolor: '#000000',
                quality: 'high',
                scale: 'exactfit',
                play: 'true',
                wmode: 'direct',
                allowScriptAccess: 'always',
                loop: 'true',
                allowFullScreenInteractive: 'true',
                allowFullScreen: 'true'
            };
            netEntLiveCasino.gameFunctions.switchToIngame(game, {
                gameHolder: options.gameHolder,
                type: 'flash',
                src: provider.staticURL + '/live_casino/roulette/roulette-application.swf',
                flashVars: flashVars,
                flashParams: flashParams,
                mode: 'real'
            });
        }).fail(function() {
            console.error('Failed to access GetNentEntGameInfo.');
        });
    }

    function freeMode(netEntLiveCasino, game, options) {
        netEntLiveCasino.gameFunctions.hideHelpButton();
        netEntLiveCasino.gameFunctions.showNoFreeMode(options.gameHolder, game);
    }

    function realMode(netEntLiveCasino, game, options, data) {
        netEntLiveCasino.gameFunctions.hideHelpButton();
        netEntLiveCasinoConfiguration(netEntLiveCasino, game, options);
        window.rules = function(url) {
            var features='directories=no,location=no,menubar=no,resizable=no,scrollbars=yes,status=no,toolbar=no,width=440,height=420';
             window.open(url, 'rules', features);
        };
        window.openLCHistory = function(url) {
            var features='directories=no,location=no,menubar=no,resizable=no,scrollbars=yes,status=no,toolbar=no,width=440,height=420';
            window.open(url, 'history', features);
        };
    }

    NetEntLiveCasino.prototype = {
        constructor: NetEntLiveCasino,
        freeMode: function(game, options) { freeMode(this, game, options); },
        realMode: function(game, options, data) { realMode(this, game, options, data); }
    };

    return NetEntLiveCasino;
});
